import React from "react";

import { TextDate } from "@performyard/py-components";
import { ScimLogModelFrontend } from "@performyard/service-contracts";

// Returns correct color string for Chip component prop from scim log status
export const getStatusColor = (status: string) => {
	switch (status) {
		case "failed":
			return "red";
		case "completed":
			return "green";
		default:
			return "green";
	}
};

// Returns TextDate component with correct props from scim log values
export const getEventTimeCell = (scimLog: ScimLogModelFrontend) => {
	if (!scimLog || !scimLog.timestamp) {
		return "";
	}
	return (
		<TextDate
			dateSize="medium"
			hasDelimiter={true}
			date={scimLog.timestamp}
			size="paragraph-3"
			hasTime={true}
		></TextDate>
	);
};

// Filters values that shouldn't be displayed in details modal from scim log
export const filterScimLog = (scimLog: ScimLogModelFrontend) => {
	const removeTypes = ["Activation Status", "Termination Date"];
	if (scimLog.scimLogType === "deactivate") {
		const filteredUpdates = scimLog.updates.filter((update) => !removeTypes.includes(update.name));
		return {
			...scimLog,
			updates: filteredUpdates,
		};
	}

	return scimLog;
};
